import { render } from "./land-transfer-count.vue?vue&type=template&id=7d6dccc6&scoped=true"
import script from "./land-transfer-count.vue?vue&type=script&lang=js"
export * from "./land-transfer-count.vue?vue&type=script&lang=js"

import "./land-transfer-count.vue?vue&type=style&index=0&id=7d6dccc6&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6dccc6"]])

export default __exports__